import "./global"
import Vue from "vue"

import Home from "./pages/home"

new Vue({
  el: "#root",
  render: (h) => h(Home),
})
